const messages = {
    ja: {
        account: {
            account_settings: 'アカウント設定',
            change_email: 'メールアドレスの変更',
            change_email_info: '新しいメールアドレスを以下に入力<br>新しいメールアドレスにアカウント認証のメールを送信します。',
            delete_account: 'アカウントの削除',
            delete_account_info: {
                header: 'あなたのアカウントと個人情報が完全に削除されます。',
                body: '削除されるデータには次のものが含まれます。',
                list: [
                    'あなたの個人情報',
                    '当社システム内の求人への応募 (求人企業がダウンロードしたデータではないもの)',
                    '職務経歴書(求人企業の候補者検索からのものを含む)',
                    'マーケティングおよび求人アラートメールの定期購読',
                ],
                footer: 'あとで新しいアカウントを作成することができます。',
            },
            delete_confirmation: '本当によろしいですか？一度削除したデータは元に戻りません。',
            delete_success_title: 'お役に立てず残念です。',
            delete_success_message: 'あなたのアカウントは削除されました。ログアウトを行います。',
            enter_code: 'コードを入力',
            resend_code: 'コードを再送信するにはここをクリック',
            reset_password: 'パスワードの再設定',
            reset_password_info: '下のボタンをクリックすると、パスワード再設定のためのコードがメールで送信されます。その後、新しいパスワードが作成できるようになります。',
            reset_password_success: 'あなたの現在のメールアドレスに再設定用のコードを送信しました。迷惑メールフォルダも必ずご確認下さい。コードを再送信するにはここをクリック',
            try_again: '10 分後にもう一度お試しください。',
        },

        api_message: {
            UserTokenNotFoundException: 'このトークンは無効のようです。',
            ValidationCaptchaException: 'グーグルのキャプチャが無効のようです。',
            ValidationException: 'いくつかのフィールドが無効のようです。',
            InvalidAuthenticationException: 'メールアドレスまたはパスワードを確認の上、もう一度お試し下さい。',
            MaxAttemptsException: '最大試行回数を超えました。',
            ResourceNotFoundException: 'リクエストが見つかりません。',
            UserNotFoundException: 'ユーザーが見つかりません。',
            SeekerNotFoundException: 'このメールアドレスを認識できないようです。ご確認の上、もう一度お試し下さい。',
            SeekerEmailResetNotFoundException: '再設定されたメールアドレスのトークンが無効のようです。',
            EmailTokenNotValidException: 'このトークンは無効のようです。',
            QueryException: '問題が発生したようです。',
            ServerErrorException: '問題が発生したようです。',
            UserConfirmationTokenNotFoundException: 'このトークンは無効のようです。',
            UserExistsException: 'このメールアドレスは既に登録されています。',
            JobNotFoundException: 'この求人は既に終了したようです。',
            UserResumeNotFoundException: 'この職務経歴書は既に存在しないようです。',
            UserJobAlertNotFoundException: 'この求人アラートは既に存在しないようです。',
            UserAppliedForJobException: 'この求人には既に応募済みのようです。',
            PromotionNotFoundException: 'このプロモーションは存在しないようです。',
            SmartfeedJobTokenNotFoundException: '応募のトークンが無効です。',
            InvalidPasswordException: 'パスワードが無効です。',
            OwnEmailNotAllowedException: '現在のメールアドレスへ変更できません。',
            FileImageSizeException: '画像のサイズが小さすぎます。最小画像サイズは150x150pxです。',
            FileSizeException: 'ファイルサイズが大きすぎます。最大ファイルサイズは20MBです。',
            GoogleCaptchaException: 'グーグルのキャプチャを検証できませんでした。',
            SeekerPasswordResetNotFoundException: 'リセットコードを再入力の上、もう一度お試し下さい。',
            InvalidFilterCriteria: '範囲が広すぎます。何か基準を設けて下さい。',
            PasswordResetTooManyAttempts: 'パスワード再設定の試行回数が上限を超えました。20秒後にもう一度お試し下さい。',
            PasswordTokenNotValid: 'パスワードコードが無効です。',
        },

        additional_document: {
            drag_and_drop_info: 'ドラッグ&ドロップまたは <br> をクリックして追加文書をアップロードする',
            file_type_info: 'pdf, docx, docのみ使用可能',
            max_document_size_info: '職務経歴書の最大サイズは10MBです。',
            not_found: '保存された追加の文書はありません。',
            remove: '追加の文書を削除しますか?',
            title: '追加の文書',
            uploaded: 'アップロード済み',
            uploaded_documents: 'アップロード済みの文書',
        },

        application: {
            title: '応募',
            not_found: '応募が見つかりませんでした。',
            view: '求人情報を見る',
        },

        apply: {
            apply_with_email_title: 'またはメールで応募する',
            apply_for_job: '求人に応募する',
            apply_as_guest: 'ゲストとして応募する',
            info: 'あなたが応募したアカウントから自動的にプロフィールが作成されます。',
            apply_with_email: '{email}で応募する',
            apply_with_linkedin: 'Linkedinで応募する',
            back: '求人ページに戻る',
            confirmation: 'へ確認メールが送信されました。',
            job_application: '求人への応募',
            loading_resume: '職務経歴書を読み込み中です。しばらくお待ち下さい。',
            success: 'ご応募ありがとうございます。',
            title: 'アカウントから応募する',
            register_and_apply: '登録して応募する',
            application_already_received: 'Application already received',
        },

        cover_letter: {
            add: 'カバーレターを追加する',
            apply_without: 'カバーレターなしで申し込む',
            drag_and_drop_info: 'ドラッグ&ドロップまたは<br>をクリックしてカバーレターをアップロードする',
            edit: 'カバーレターの編集',
            file_type_info: 'pdf, docx, docのみ使用可能',
            max_document_size_info: '職務経歴書の最大サイズは10MBです。',
            not_found: '保存されたカバーレターはありません。',
            remove: 'カバーレターを削除しますか?',
            title: 'カバーレター',
            uploaded: 'アップロード済み',
            uploaded_documents: 'アップロード済みのカバーレター',
            write_new: '新しいカバーレターを作成する',
        },

        dashboard_menu: {
            applications: '応募',
            saved_jobs: '保存された求人情報',
            job_alerts: '求人アラート',
            profile_details: 'プロフィール詳細',
            work_preferences: '希望職種',
            documents: '文書データ',
            account_settings: 'アカウント設定',
            logout: 'ログアウト',
        },

        filter: {
            clear_all: 'すべてクリア',
            info: '上のユーザー検索でもっと探す',
            see_less: 'もっと少なく見る',
            see_all_value: '{value}のフィルターをすべて見る',
        },

        forgot_password: {
            title: 'パスワードを忘れた場合',
            info: 'メールアドレスを入力していただくと、アカウントが存在する場合は、パスワード再設定のためのコードが送信されます。',
            resend_code: 'ここをクリックしてコードを再送',
            success: '以下のメールアドレスに再設定用のコードを送信しました。迷惑メールフォルダも必ずご確認下さい。',
            success_resend_code: '以下のメールアドレスに再設定用のコードを送信しました。迷惑メールフォルダも必ずご確認下さい。',
            try_again: '{countDown} 秒後にもう一度お試しください',
        },

        create_password: {
            title: 'パスワードを作成する',
            info: 'おかえりなさい。あなたのパスワードは失効しているようです。パスワード再設定用のPINコードをメールでお送りしました。PINコードを入力し、以下よりパスワードの再設定を行って下さい',
        },

        global: {
            currency_format: '¥{0}',
            currency_symbol: '¥',
        },

        job_alert: {
            create: '求人アラートの作成',
            error: '求人アラートの作成ができません。更新して再度お試し下さい',
            manage: '求人アラートの管理',
            not_found: '保存された求人アラートはありません',
            remove: '保存されたこの求人アラートを削除しますか?',
            save: '求人アラートを保存する',
            saved: '保存された求人アラート',
            search_term: '検索用語',
            success: '求人アラートが作成されました。ありがとうございます',
            success_remove: 'ジョブアラートが削除されます。ありがとうございました',
            title: '求人アラート',
        },

        job_view: {
            date_posted: '投稿日',
            expired: 'この求人は終了しました。',
            expired_desc: 'This job is no longer available. Please view our full list of jobs by clicking \'See more results\'.',
            posted_on: '～に投稿',
            see_desc: '職務内容を見る',
            hide_desc: '職務内容を非表示にする',
            other_jobs: '類似した求人情報',
        },

        single_job: {
            backToSearchUrl: '求人情報',
            see_more_results: '更に結果を見る',
            see_more_results_2: 'すべての求人に戻る',
        },

        label: {
            add_all: '興味のあるすべての{value}を追加',
            add_value: '{value}を追加',
            additional_documents: '追加文書',
            alert_name: 'アラート名',
            alert_name_placeholder: '検索名を入力する',
            already_have_account: '既にアカウントをお持ちですか？',
            annual_salary: '年収',
            annualy: '毎年',
            any: 'どれでも',
            any_value: '{value}のどれでも',
            applied: 'Applied',
            apply_again: 'もう一度応募する',
            apply_as_guest: 'ゲストとして応募する',
            apply_now: '今すぐ応募する',
            quick_apply: '迅速な適用',
            availability: '有効性',
            back: '戻る',
            back_to_value: '{value}へ戻る',
            base_pay: '基本給',
            basic_information: '基本情報',
            cancel: 'キャンセル',
            career_level: 'キャリアレベル',
            certifications: '資格',
            change_email: 'メールアドレスの変更',
            classification: '区分',
            classification_select: 'Select classifications from below',
            company: '会社',
            company_placeholder: '会社名を入力（例：ALDI Australia）',
            company_size: '会社の規模',
            confirm_password: 'パスワードの確認',
            confirm_remove: 'はい、削除します',
            consultant: 'コンサルタント',
            contact_number: '電話番号',
            contact_number_placeholder: '電話番号を入力',
            continue_to_apply: '続けて応募する',
            contract_type: '契約形態',
            country: 'Country',
            country_of_citizenship: 'Country of citizenship',
            course_name: 'コース名',
            cover_letter: 'カバーレター',
            cover_letter_custom_name: 'カスタムカバーレター名の入力',
            cover_letter_name: 'カバーレター名',
            cover_letters: 'カバーレター',
            create: '作成する',
            create_job_alert: '求人アラートを作成する',
            create_password: 'パスワードの作成',
            current_role: '現在の職務',
            daily: 'Daily',
            date_posted: '投稿日',
            delete_my_account: 'アカウントを削除する',
            description: '説明',
            desired_occupations: '希望職種',
            desired_pay: '希望年収',
            desired_work_locations: '希望勤務地',
            dob: '生年月日',
            dont_have_account: 'アカウントをお持ちではないですか？',
            download: 'ダウンロード',
            edit: '編集',
            edit_value: ' {value}を編集',
            education: '学歴',
            email: 'Eメール',
            email_address: 'メールアドレス',
            email_address_placeholder: 'メールアドレスを入力',
            email_alert_frequency: 'Eメールアラートの頻度',
            email_me_code: 'Email meコード',
            email_to: '～へメールを送信する',
            emergency_contact_name: '緊急連絡先の名前',
            emergency_contact_number: '緊急連絡先番号',
            emergency_contact_rel: '緊急連絡関係',
            end_date: '終了日',
            enter_code: 'コードを入力',
            enter_current_password: '現在のパスワードを入力',
            enter_current_password_for_email: '現在のパスワードを入力して、メールアドレスの変更を確認する',
            enter_new_email: '新しいメールアドレスを入力',
            enter_new_password: '新しいパスワードを入力',
            enter_the_value: ' {value}を入力',
            enter_value: '{value}を入力',
            enter_your_value: '{value}を入力',
            enter_your_value_again: '{value}を再入力',
            expires_at: 'Closing date',
            filters: 'フィルター',
            find_jobs_now: '今すぐ求人を探す',
            first_name: '名',
            first_name_placeholder: '名を入力',
            forgot_password: 'パスワードを忘れた場合',
            frequency: '頻度',
            gender: '性別',
            go: '年収の設定',
            home_location: '居住地',
            hourly: '毎時',
            hourly_rate: '時給',
            in_progress: '進行中',
            industries: 'あなたが興味のある業界',
            institution_name: '機関名',
            is_contactable: 'May we contact this referee?',
            is_report_directly: 'Did you report directly to this referee?',
            job_mode: '勤務形態',
            job_title: '役職',
            job_title_placeholder: 'あなたの役職名を入力して下さい（例：会計士）',
            job_type: '職種',
            job_type_placeholder: '職種を選択',
            keyword: 'キーワード',
            languages: '言語',
            last_name: '苗字',
            last_name_placeholder: '苗字を入力',
            licenses_and_certifications: '免許・資格',
            licenses_or_certifications: '免許または資格',
            location: '勤務地',
            login: 'ログイン',
            look_for_all_jobs: '利用可能なすべての仕事を探す',
            max: '最大',
            message: 'メッセージ',
            min: '最小',
            mobile_number: 'Mobile number',
            mobile_number_placeholder: 'Enter mobile number',
            modified: '修正済み',
            new_cover_letter_details: '新しいカバーレターの詳細',
            no_industries: '希望する業界は特にありません。',
            no_job_mode: '希望する勤務形態は特にありません。',
            not_added_value: '{value}は追加されていません。',
            not_found: '見つかりませんでした。',
            null_pay_included: '給与の詳細がない求人を含める',
            occupation: '職業',
            occupation_placeholder: '興味のある職業をすべて追加',
            off: 'オフ',
            password: 'パスワード',
            payband_placehoder: '最も近い値を選んで下さい。',
            per_day: '1日あたり',
            perks_and_benefits: '福利厚生、諸手当',
            phone_number: 'Phone number',
            phone_number_placeholder: 'Enter phone number',
            placeholder_email: 'Eメール',
            placeholder_password: 'パスワード',
            position: 'Position',
            position_placeholder: 'Enter position',
            print: '印刷',
            profession: '専門職',
            profile_picture: 'プロフィール写真',
            qualification_type: '資格の種類',
            range: '範囲',
            recover_password: 'パスワードの復元',
            reference: '参考',
            reference_number: '参照番号',
            register: '登録',
            relevance: '関連性',
            remove: '削除',
            required_value: '{value}フィールドは必須項目です。',
            reset: '再設定',
            reset_password: 'パスワードの再設定',
            resumes: '職務経歴書',
            salary: '給与',
            salary_type: '給与タイプ',
            salary_currency: '給与通貨',
            salary_any_currency: '任意の通貨',
            save: '保存',
            save_cover_letter: 'カバーレターを保存',
            save_job: '求人情報を保存',
            save_value: '{value}を保存',
            save_work_experience: '職務経験を保存',
            search_by_location: '都道府県または地域で検索',
            search_jobs: '検索',
            search_keyword: 'キーワードを入力',
            search_within_value: '{value1} {value2}の中から検索',
            sector: '業種',
            select_location: 'すべての勤務地',
            select_value: '{value}を選択',
            share: '共有する',
            sign_in: 'サインイン',
            sign_in_and_apply: 'サインインして応募する',
            skills: 'スキル',
            sort_by: '並び替え',
            start_date: '勤務開始日',
            start_end_dates: '開始日と終了日',
            sub_classification: 'サブ区分',
            sub_classification_select: 'Select subclassifications',
            submit: 'Submit',
            suburb_city_area: '都道府県または地域',
            unsave: 'Unsave',
            upload_file_size: 'File size 10MB max',
            upload_label: 'Tap to upload document',
            upload_new: 'Upload new',
            upload_new_additional_document: '新たな追加文書のアップロード',
            upload_new_cover_letter: '新しいカバーレターのアップロード',
            upload_new_resume: '新しい職務経歴書のアップロード',
            upload_profile_picture: 'プロフィール写真のアップロード',
            uploaded: 'Uploaded',
            uploaded_document: 'Uploaded document',
            uploaded_now: 'just now',
            view_job: '求人を見る',
            weekly: '毎週',
            what_is_this: 'これは何ですか',
            what_is_this_occupation: 'この「職業」は、あなたに合った求人をお勧めするために使用されます。役職に最も関連する職業を選択して下さい。',
            work_authorisation: '就労許可',
            work_experience: '職務経験',
            work_location: '勤務地',
            work_occupation_placeholder: '職業を入力してください',
            work_preferences: '希望職種',
            work_type: '業務の種類',
            write_a_cover_letter: 'カバーレターを作成する',
            write_cover_letter: 'カバーレターを作成する',
        },

        login: {
            welcome_back: 'おかえりなさい',
            welcome: 'ようこそ',
            title: 'ログイン',
            info: '',
            back: 'ログインへ戻る',
        },

        profile: {
            basic_information: '基本情報',
            not_found_location: '現在、この場所での求人情報はサポートしていません。新しい場所をリクエストするには、お問い合わせください。',
            not_found_global_location: '一致する場所が見つかりません。別の検索を試すか、場所として国を選択してください。',
            pay_info: 'あなたの給与情報は、我々があなたのキャリア履歴をより良く理解し、今後のキャリアの発展をサポートするのに役立ちます。',
            profile_details: 'プロフィール詳細',
        },

        register: {
            welcome: 'ようこそ',
            welcome_aboard: 'ようこそ!',
            info: '',
            back: '登録へ戻る',
        },

        reset_email: {
            title: 'メールアドレスの再設定',
            success: 'メールアドレスが再設定されました。',
        },

        reset_password: {
            title: 'パスワードを作成する',
            info: 'あなたのアカウントのメールアドレスと新しいパスワードを入力して下さい',
            success: '新しいパスワードの作成が完了しました。',
        },

        resume: {
            apply_without: '職務経歴書なしで申し込む',
            default: 'デフォルトの職務経歴書',
            dropbox_title: 'ドロップボックスからアップロードする',
            default_option: '今後の応募用にデフォルト設定する',
            default_text: '職務経歴書のオプションを選択する',
            drag_and_drop_info: 'ドラッグ&ドロップまたは <br> をクリックして職務経歴書をアップロードする',
            drag_and_drop_size: '(ファイルサイズ最大10MB)',
            file_type_info: 'pdf, docx, doc, rtf, txt, odt, pagesのみ使用可能(最大10MB)',
            googledrive_title: 'グーグルドライブからアップロード',
            max_resume_size_info: '職務経歴書の最大サイズは10MBです。',
            new: '新しい職務経歴書のアップロード',
            not_found: 'アップロードされた職務経歴書はありません。',
            remove: '職務経歴書を削除しますか?',
            title: '職務経歴書',
            upload_documents: '文書のアップロード',
            upload: '職務経歴書をアップロードする',
            uploaded: 'アップロード完了',
            uploaded_resumes: '職務経歴書を選択',
            upload_via: '{service}からアップロード',
            ducment_uploaded: '文書のアップロード完了',
        },

        saved_job: {
            saved_jobs: '保存された求人情報',
            not_found: '保存された求人情報はありません。',
        },

        search_results: {
            not_found: '申し訳ありませんが、その検索条件では求人が見つかりませんでした。',
            showing: '表示中',
            separator: 'へ',
            of: 'の',
            results: '検索結果',
            listView: 'List View',
            mapView: 'Map View',
            mapViewLocation: 'Location',
            mapViewRadius: 'Within (KM)',
            mapViewUpdate: 'Update Map',
            mapViewReset: 'Reset Map',
        },

        share: {
            facebook: 'Post',
            linkedin: 'Share',
            title: '～で共有する',
            twitter: 'Tweet',
        },

        terms: {
            link: 'ご利用を続行することにより、当社の規約に同意をしたものとみなされます。',
            terms: '規約',
            and: 'と',
            privacy: 'プライバシーポリシー',
            validation_message: '当社の規約に同意して下さい。',
        },

        work_preferences: {
            work_preferences: '希望職種',
            next_role: 'あなたの次の仕事',
            other: 'その他の希望',
            job_type: '職種',
            contract_type: '契約形態',
        },

        work_experience: {
            add: '職務経験を追加しますか?',
            edit: '職務経験を編集しますか?',
            remove: '職務経験を削除する',
        },

        education: {
            add: '学歴の追加',
            remove: '学歴の削除',
        },

        reference: {
            add: '審判を追加',
            remove: '審判を外す',
        },

        searchbar: {
            keywords_label: 'キーワード',
            classifications_label: '分類',
            locations_label: '勤務地',
        },

        screening: {
            confirm_and_finish: '確認して終了',
            title: 'Complete additional questions',
            sub_title: 'Improve your chances of being considered for this job by completing the below questions',
        },

        networks: {
            facebook: {
                shareText: 'Post',
            },
            twitter: {
                shareText: 'Tweet',
            },
            linkedin: {
                shareText: 'Share',
            },
        },
    },
};

export default messages;
